export default __webpack_public_path__ + "static/media/icici-logo.33193976.png";